module.exports = __webpack_public_path__ + "assets/img/sign.20eed5ca.png";